import { ReactElement } from "react";
import { Circle, Path, Rect, PathProps } from "react-native-svg";

interface PathElementProps {
  path: string;
  color: string;
  outlined: boolean;
  strokeWidth?: string;
  hasRoundStroke?: boolean;
}

export const PathElement = ({
  path,
  color,
  outlined = true,
  strokeWidth,
  hasRoundStroke = true,
  ...props
}: PathElementProps & PathProps): ReactElement => (
  <Path
    d={path}
    fill={outlined ? "none" : color}
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap={hasRoundStroke ? "round" : "square"}
    strokeLinejoin={hasRoundStroke ? "round" : undefined}
    {...props}
  />
);

interface CircleElementProps {
  cx: string;
  cy: string;
  r: string;
  outlined: boolean;
  color: string;
}

export const CircleElement = ({ outlined, color, ...props }: CircleElementProps): ReactElement => (
  <Circle {...props} fill={outlined ? "none" : color} stroke={color} />
);

interface RectElementProps {
  width: string;
  height: string;
  x?: string;
  y?: string;
  outlined: boolean;
  color: string;
}

export const RectElement = ({ outlined = true, color, ...props }: RectElementProps): ReactElement => (
  <Rect {...props} fill={outlined ? "none" : color} stroke={color} />
);
